var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSustainabilityBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3145 13.75C17.3145 11.562 16.4388 9.46354 14.88 7.91637C13.3213 6.36919 11.2072 5.5 9.00285 5.5H4.84705V8.25C4.84705 10.438 5.72273 12.5365 7.28146 14.0836C8.84019 15.6308 10.9543 16.5 13.1587 16.5H17.3145",
    stroke: "#0C6CDE",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3145 19.25C17.3145 17.062 18.1901 14.9635 19.7489 13.4164C21.3076 11.8692 23.4217 11 25.6261 11H29.7819V12.375C29.7819 14.563 28.9062 16.6615 27.3474 18.2086C25.7887 19.7558 23.6746 20.625 21.4703 20.625H17.3145",
    stroke: "#0C6CDE",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3145 27.5V13.75",
    stroke: "#0C6CDE",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSustainabilityBlue);
export default __webpack_public_path__ + "static/media/Icon_Sustainability_Blue.b7a99418cf63d6cc97d79ee9e88f03ce.svg";
export { ForwardRef as ReactComponent };